import { render, staticRenderFns } from "./b-table-report-builder.vue?vue&type=template&id=115c8b07&scoped=true"
import script from "./b-table-report-builder.vue?vue&type=script&lang=js"
export * from "./b-table-report-builder.vue?vue&type=script&lang=js"
import style0 from "./b-table-report-builder.vue?vue&type=style&index=0&id=115c8b07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115c8b07",
  null
  
)

export default component.exports